export default "__VITE_ASSET__Dbrr_EUB__"